<mat-chip
  [value]="_category?.id"
  [selected]="selected"
  (click)="toggle()"
  [color]="'secondary'"
>
  <div [class.animate]="animate" class="animationHolder">
    <ng-lottie [options]="animation"></ng-lottie>
  </div>
  {{ _category?.name }}
</mat-chip>
